import { makeStyles } from "@material-ui/core";

export  const style = {
    paper: {
      marginTop: 8,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
    },
    form: {
      width: "100%",
      marginTop: 20,
    },
    submit: {
      marginTop: 15,
    },
  
    avatar: {
      margin: 5,
      backgroundColor: "#1976d2",
      width: 60,
      height: 60
    },
    icon: {
      fontSize: 40,
    },
    iconMed: {
      fontSize: 18,
      display: 'flex',
      alignItems: 'center'
    },
    avatarWarnVisible: {
      margin: 2,
      backgroundColor: "red",
      width: 22,
      height: 22,
      display: 'flex',
      alignItems: 'center'
    },
    avatarWarnNotVisible: {
     display:'none'
    },
    textoBaja:{
      color: "red",
      fontWeight: "bold"
  
    },
    textoAlta:{
      color: "black",
    }
  };

 export const useStylesMUI = makeStyles((theme) => ({
  root:{
    flexGrow: 1,
  },
  page: {
    marginTop: "2.5em"
  },
  color: {
    backgroundColor: theme.palette.primary.main,
  },
  lightColor: {
    backgroundColor: theme.palette.primary.light,
  },
  textColor: {
    color: theme.palette.secondary.main,
  },
  secondaryColor: {
    backgroundColor: theme.palette.secondary.main,
  },
  lightSecondaryColor: {
    backgroundColor: theme.palette.secondary.light,
  }
}));